import styles from './register-layout.module.css';
import { Button } from '@/components/button';
import { UserEntryLayout, UserEntryLayoutBanner } from '@/components/auth/user-entry-layout';
import { useTranslation } from '@/contexts/i18n-context';
import { MarketingSpot } from '@/components/marketing-spot';

interface RegisterLayoutProps {
  children: React.ReactNode;
}

export function RegisterLayout({ children }: RegisterLayoutProps) {
  const { t } = useTranslation();

  return (
    <>
      <UserEntryLayout
        titleContent={<MarketingSpot page="accountCreation" spot="top" />}
        titleClassName={styles.title}
      >
        {children}
        <p className={styles.loginLink}>
          {t('register.loginLink')}
          <Button
            variant="link"
            className={styles.loginButton}
            color="accent"
            key="login-link"
            as="a"
            to="/login"
          >
            {t('common.logIn')}
          </Button>
        </p>
        <MarketingSpot page="accountCreation" spot="bottom" className={styles.marketingContent} />
      </UserEntryLayout>
      <UserEntryLayoutBanner />
    </>
  );
}
